/**
 * Created by Jerker Nord on 2020-01-31.
 */

export class ParticleConfigs {

    public static bigWinCenter:any = {
        "alpha" : {
            "start" : 0.49,
            "end" : 0.79
        },
        "scale" : {
            "start" : 0.5,
            "end" : 0.05,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#54f587",
            "end" : "#0998eb"
        },
        "speed" : {
            "start" : 150,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 0.2,
            "max" : 2.6
        },
        "blendMode" : "screen",
        "frequency" : 0.001,
        "emitterLifetime" : -1,
        "maxParticles" : 300,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "circle",
        "spawnCircle" : {
            "x" : 0,
            "y" : 0,
            "r" : 50
        }
    };
    public static bigWinLevel01:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 235,
            "max" : 310
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 20,
            "max" : 40
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.02,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    public static bigWinLevel02:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 235,
            "max" : 310
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 20,
            "max" : 40
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.06,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    public static bigWinLevel03:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 235,
            "max" : 310
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 20,
            "max" : 40
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    public static bigWinLevel04:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 235,
            "max" : 310
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 20,
            "max" : 40
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    public static bigWinSparkle:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 235,
            "max" : 310
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 20,
            "max" : 40
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    public static mediumAndLargeWin:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.8,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 700,
            "end" : 350,
            "minimumSpeedMultiplier" : 1.3
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -110,
            "max" : -70
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2.1,
            "max" : 2.1
        },
        "blendMode" : "normal",
        "frequency" : 0.002,
        "emitterLifetime" : 0.1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 360,
            "y" : 720 + 40,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -100,
            "y" : -25,
            "w" : 200,
            "h" : 50
        }
    };
}